export default {
    "quiz.title": "Quiz interactifs",
    "quiz.title_highlight": "par Thématique",
    "quiz.subtitle": "Validez vos connaissances chapitre par chapitre pour une mémorisation optimale.",

    "quiz.nav.back_themes": "Retour aux thématiques",
    "quiz.nav.retry": "Recommencer le quiz",
    "quiz.nav.next": "Question suivante",
    "quiz.nav.submit": "Valider ma réponse",
    "quiz.nav.finish": "Terminer le quiz",
    "quiz.nav.finish_session": "Terminer ma session",
    "quiz.nav.quit": "Quitter",

    "quiz.mode.qcm.title": "Mode QCM",
    "quiz.mode.qcm.description": "4 options, 1 seule bonne réponse. Le format officiel de l'examen.",
    "quiz.mode.vrai_faux.title": "Mode Vrai ou Faux",
    "quiz.mode.vrai_faux.description": "Testez vos connaissances sur des affirmations précises.",
    "quiz.mode.locked_pro": "PRO",
    "quiz.mode.upgrade_pro": "DÉBLOQUER TOUT L'ACCÈS",
    "quiz.mode.limit_reached": "Limite de {{count}} questions par quiz atteinte en version gratuite.",

    "quiz.retry_errors.title": "Renforcement ciblé",
    "quiz.retry_errors.subtitle": "Vous avez {{count}} questions en attente de révision dans ce thème.",
    "quiz.retry_errors.qcm": "Réessayer QCM",
    "quiz.retry_errors.vrai_faux": "Réessayer Vrai/Faux",

    "quiz.status.no_questions": "Aucune question disponible",
    "quiz.status.no_questions_desc": "Toutes les questions de ce mode ont été réussies ! Bravo.",
    "quiz.status.question": "Question {{current}} sur {{total}}",
    "quiz.status.score": "Score : {{score}}",

    "quiz.vrai_faux.true": "Vrai",
    "quiz.vrai_faux.false": "Faux",

    "quiz.feedback.correct": "C'est exact !",
    "quiz.feedback.incorrect": "C'est incorrect.",
    "quiz.feedback.explanation": "Explication",

    "quiz.result.title": "Quiz terminé !",
    "quiz.result.perfect": "Incroyable ! Un sans-faute parfait.",
    "quiz.result.good": "Très bon travail ! Vous maîtrisez bien ce sujet.",
    "quiz.result.average": "C'est un bon début. Continuez à pratiquer !",
    "quiz.result.bad": "Besoin d'un peu plus de révisions sur ce chapitre.",
    "quiz.result.stats.questions": "Questions",
    "quiz.result.stats.correct": "Réussies",
    "quiz.result.stats.accuracy": "Précision",

    "quiz.badges.new": "Nouveau Badge !",
    "quiz.badges.congrats": "Félicitations pour vos efforts constants.",
    "quiz.badges.close": "Continuer"
};
